exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".activity---1THe9{width:calc(100% - 40px);margin:0 20px;background-color:#fff;border-radius:16px 16px 0 0;position:relative;max-width:1200px}.activity---1THe9 .inner-scroll---J442S{overflow-y:auto;padding:20px 20px 20px 45px;padding-right:30px;width:100%;height:100%}.activity---1THe9 .inner-scroll---J442S .qtc-wrapper *[data-type=\"default-content\"]{line-height:normal}.activity---1THe9 .tri---2dQKL{position:absolute;right:0;bottom:0;transform:translate(0, 100%)}", ""]);

// exports
exports.locals = {
	"activity": "activity---1THe9",
	"inner-scroll": "inner-scroll---J442S",
	"tri": "tri---2dQKL"
};